import { isDailyMotionVideo, OneMedia } from '@prismamedia/one-components';
import { useMemo } from 'react';
import { useGlobalThumbnail } from './globalState';

const applyThumbnailToMedia = (
  media: OneMedia,
  thumbnailUrl: string,
): OneMedia => {
  const thumbnails = media.iframely?.links?.thumbnail;
  if (!isDailyMotionVideo(media) || !thumbnails?.length) return media;
  const [first, ...rest] = thumbnails;
  return {
    ...media,
    iframely: {
      ...media.iframely,
      links: {
        ...media.iframely.links,
        thumbnail: [{ ...first, href: thumbnailUrl }, ...rest],
      },
    },
  };
};

export const useDailymotionThumbnail = (
  medias: OneMedia[],
  isVideo: boolean,
): OneMedia[] => {
  const [thumbnail] = useGlobalThumbnail();
  return useMemo(() => {
    if (!isVideo || !thumbnail) return medias;
    return medias.map((media) => applyThumbnailToMedia(media, thumbnail));
  }, [isVideo, medias, thumbnail]);
};
